import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const styles = makeStyles(() => ({
  label: {
    textAlign: "left",
  },
  labelDisabled: {
    textAlign: "left",
    color: "#667085",
  },
  p0: {
    padding: 0,
  },
  button: {
    justifyContent: "flex-start",
  },
  activityButton: {
    color: colors.brandBlue500,
    border: `1px solid ${colors.brandBlue500}`,
    "&:hover": {
      color: colors.brandBlue500,
      border: `1px solid ${colors.brandBlue500}`,
    },
    "&:focus": {
      color: colors.brandBlue500,
      border: `1px solid ${colors.brandBlue500}`,
    },
  },
  buttonDisabled: {
    justifyContent: "flex-start",
    opacity: 0.5,
    cursor: "default",
  },
}));

export default styles;
